// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__tXBQY","subTitleBold":"BoxSubTitle_subTitleBold__pHJTy"};